import styled from 'styled-components';

export const List = styled.ul`
  list-style: none;
  display: flex;
  gap: 10px;
  flex-direction: column;
  margin-left: 40px;
  font-size: 22px;
`;
